import React, { Component } from 'react';

import SimpleVideoPlayer from '../arhiveComponents/SimpleVideoPlayer';


class MediaModal extends Component {
  render() {
    return (
      <div id="media-modal">
        <span className="media-modal-close" onClick={this.props.closeMediaModal}>×</span>
        <div className="media-modal-content">
          <SimpleVideoPlayer
            audition={this.props.audition}
          />
        </div>
      </div>
    );
  }
}

export default MediaModal;
